<template>
  <div class="questionnaire">
    <img class="head-banner" :src="BannerSrc" alt="">
    <van-tabs v-model="active" @change="changeTabs">
      <van-tab title="进行中">
        <van-empty v-if="list.length===0" description="暂无问卷数据"/>
        <van-list class="circleList" v-model="loading" :finished="finished" @load="onLoad">
          <questionnaire-card v-for="item in list" :key="item.id" @click.native="goOutLink(item)"
                              :itemData="item"/>
        </van-list>
      </van-tab>
      <van-tab title="待审核">
        <van-empty v-if="list2.length===0" description="暂无问卷数据"/>
        <van-list class="circleList" v-model="loading2" :finished="finished2" @load="onLoad2">
          <questionnaire-card v-for="item in list2" :key="item.id" @click.native="goOutLink(item)"
                              :itemData="item"/>
        </van-list>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
  import questionnaireCard from './components/questionnaireCard'
  import untils from "@/until/until"
  import wxLogin from '@/until/wxLogin.js'
  import {Toast} from "vant";

  export default {
    name: "questionnaire",
    components: {
      questionnaireCard
    },
    data() {
      return {
        BannerSrc: '',

        active: 0,

        loading: false,
        finished: false,
        list: [],
        pageNum: 1,
        pageSize: 15,

        loading2: false,
        finished2: false,
        list2: [],
        pageNum2: 1,
        pageSize2: 15
      };
    },
    async mounted() {
      if (!localStorage.sessionKey && untils.isWechat()) {
        const res = await wxLogin.getWechatAppId()
        await wxLogin.wxLogin(window.location.href, res.data.appId)
      } else {
        let UserInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {}
        if (!UserInfo.phone || UserInfo.phone === null || UserInfo.phone === '') {
          // this.$router.push('/login?type=2')
          if (untils.isWechat()) {
            const res = await wxLogin.getWechatAppId()
            await wxLogin.wxLogin(window.location.href, res.data.appId)
          }
        }
      }

      this.getBanner()

      this.$nextTick(()=>{
        if (sessionStorage.tabNum >= 0) {
          this.active = Number(sessionStorage.tabNum)
          this.changeTabs(this.active)
        }
      })
    },
    methods: {
      onLoad() {
        this.$api.home.activityList({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }, res => {
          if (res.code == 200) {
            if (this.list.length >= res.total || (res.rows && res.rows.length === 0)) {
              this.finished = true
              return false
            }
            this.list = this.list.concat(res.rows)
            this.pageNum++
            this.loading = false
          }
        })
      },
      onLoad2() {
        this.$api.home.activityList({
          pageNum: this.pageNum2,
          pageSize: this.pageSize2,
          status: 0
        }, res => {
          if (res.code == 200) {
            if (this.list2.length >= res.total || (res.rows && res.rows.length === 0)) {
              this.finished2 = true
              return false
            }
            this.list2 = this.list2.concat(res.rows)
            this.pageNum2++
            this.loading2 = false
          }
        })
      },
      //获取banner
      getBanner() {
        this.$api.home.bannerList({
          type: 2
        }, res => {
          if (res.code == 200) {
            this.BannerSrc = res.rows[0].picUrl
          }
        })
      },
      changeTabs(index) {
        sessionStorage.tabNum = index
        if (index === 0) {
          this.finished = false
          this.loading = false
          this.finished2 = true
          this.loading2 = true
        } else {
          this.finished = true
          this.loading = true
          this.finished2 = false
          this.loading2 = false
        }
      },
      //跳转
      goOutLink(item) {
        if (item.status == 0){
          Toast("该问卷暂未开始，请耐心等待")
        }else if (item.status == 1){
          switch (item.sampleStatus) {
            case 0:
              Toast("审核中，请耐心等待")
              break
            case 1:
              Toast("审核已通过")
              break
            case 2:
              Toast("审核已驳回")
              break
            default:
              window.open(item.accessLinks)
              break
          }
        }else {
          switch (item.sampleStatus) {
            case 0:
              Toast("审核中，请耐心等待")
              break
            case 1:
              Toast("审核已通过")
              break
            case 2:
              Toast("审核已驳回")
              break
            default:
              Toast("该调查已结束")
              break
          }
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .questionnaire {
    padding: 28px 30px 30px;
    width: 100%;
    box-sizing: border-box;
    background-color: #ffffff;
    min-height: 100vh;

    .head-banner {
      width: 690px;
      height: 240px;
      object-fit: cover;
      border-radius: 15px;
      margin-bottom: 30px;
    }
  }
</style>
